@if (isMatListItem() === false) {
  <mat-form-field [appearance]="appearance()" [floatLabel]="floatLabel" class="flex-1">
    <mat-label>{{label()}}</mat-label>
    <div matSuffix="" class="flex items-center">
      @if (isLoadingRates === true) {
        <mat-spinner diameter="14" class="mx2"></mat-spinner>
      }
    </div>
    <input [formControl]="control()" type="text" matInput="" [matAutocomplete]="rateAutoComplete" [required]="required() !== false" [attr.cdkFocusInitial]="focus() !== false ? 'true' : null" autocomplete="off">
    <mat-autocomplete autoActiveFirstOption="" #rateAutoComplete="matAutocomplete" [displayWith]="displayWithRate">
      @if (required() === false) {
        <mat-option [value]="null">
          <span translate="">None</span>
        </mat-option>
      }
      @for (rate of ratesFiltered; track rate) {
        <mat-option [value]="rate">
          {{rate.productName}}
        </mat-option>
      }
    </mat-autocomplete>
  </mat-form-field>
} @else {
  <mat-list-item>
    <label>{{label()}}</label>
    <mat-form-field floatLabel="never" class="inline-field">
      <div matSuffix="" class="flex items-center">
        @if (isLoadingRates === true) {
          <mat-spinner diameter="14" class="mx2"></mat-spinner>
        }
      </div>
      <input [formControl]="control()" type="text" matInput="" [matAutocomplete]="rateAutoComplete" [required]="required() !== false" [attr.cdkFocusInitial]="focus() !== false ? 'true' : null" autocomplete="off">
      <mat-autocomplete class="inline-autocomplete extendable-autocomplete" #rateAutoComplete="matAutocomplete" [displayWith]="displayWithRate">
        @if (required() === false) {
          <mat-option [value]="null">
            <span translate="">None</span>
          </mat-option>
        }
        @for (rate of ratesFiltered; track rate) {
          <mat-option [value]="rate">
            <span class="inline-autocomplete-option">{{rate.productName}}</span>
          </mat-option>
        }
      </mat-autocomplete>
    </mat-form-field>
  </mat-list-item>
}
